var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.055,4.5093c-6.3459-.0616-11.5404,5.0334-11.6012,11.3793-.0616,6.3467,5.0334,11.5404,11.3793,11.602.0742.0009.1476.0009.2219,0,3.8237,0,5.3919-1.9975,5.5699-3.7099.2716-2.5812-1.9376-3.6626-3.8373-4.1139-.3813-.0903-1.7048-.3551-1.925-.4041-1.4787-.3205-1.9975-.6512-2.0565-1.3218-.0346-.4353.135-.8621.4589-1.1548.3965-.3846,1.019-.6318,1.7512-.6951,1.1379-.0979,2.1654.2311,2.8984.927l1.0047-1.0569c-1.0392-.9895-2.4699-1.4594-4.0287-1.3244-1.0814.0945-1.9958.4749-2.6411,1.1016-.6402.5981-.9709,1.456-.8967,2.329.1712,1.9721,2.2193,2.4116,3.2004,2.6217.2328.0506,1.5352.3104,1.9013.3973,2.6149.6217,2.8031,1.7495,2.7221,2.5424-.1173,1.1076-1.2653,2.4015-4.119,2.4015-5.5302-.0076-10.0077-4.4969-9.9993-10.0271.0076-5.5302,4.4969-10.0069,10.0271-9.9993,5.5302.0076,10.0069,4.4969,9.9993,10.0271-.0025,1.3218-.2657,2.6301-.7761,3.8499l1.348.5609c2.4462-5.8625-.3222-12.5982-6.1857-15.0453-1.3986-.5837-2.9001-.8857-4.4159-.8874",
    fill: "#50b8b9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.2ef0ed72795b0339238f1116a8525aab.svg";
export { ForwardRef as ReactComponent };